import { render, staticRenderFns } from "./certificate-table.vue?vue&type=template&id=5a88d641&scoped=true&"
import script from "./certificate-table.ts?vue&type=script&lang=ts&"
export * from "./certificate-table.ts?vue&type=script&lang=ts&"
import style0 from "./certificate-table.scss?vue&type=style&index=0&id=5a88d641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88d641",
  null
  
)

export default component.exports